import React from "react";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Button,
  Avatar,
  Stack,
} from "@mui/material";
import { useEffect } from "react";
import hero from "../assets/coffee.jpg";
const brown = "#6b4f3b";

/* =========================
   DATI MENU
========================= */
/* =========================
   DATI MENU AGGIORNATI
========================= */

/* =========================
   DATI MENU PREMIUM
========================= */

const drinks = [
  // ☕ Caffetteria
  {
    name: "Caffè Espresso",
    price: "1,40€",
    desc: "Caffè classico, intenso e aromatico.",
  },
  {
    name: "Caffè Macchiato",
    price: "1,50€",
    desc: "Espresso con un tocco di latte.",
  },
  {
    name: "Cappuccino",
    price: "1,70€",
    desc: "Espresso con latte montato a regola d’arte.",
  },
  {
    name: "Latte Macchiato",
    price: "2,00€",
    desc: "Latte caldo con un filo di caffè.",
  },
  {
    name: "Orzo Piccolo",
    price: "1,50€",
    desc: "Bevanda d’orzo dal gusto delicato.",
  },
  {
    name: "Orzo Grande",
    price: "1,70€",
    desc: "Versione più ricca della bevanda d’orzo.",
  },
  {
    name: "Ginseng Piccolo",
    price: "1,50€",
    desc: "Caffè al ginseng formato piccolo.",
  },
  {
    name: "Ginseng Grande",
    price: "1,70€",
    desc: "Caffè al ginseng formato grande.",
  },
  {
    name: "Latte con Cacao",
    price: "2,00€",
    desc: "Latte caldo con cacao naturale.",
  },
  {
    name: "Tè Caldo",
    price: "2,50€",
    desc: "Tè selezionati per un momento di relax.",
  },
  {
    name: "Caffè Corretto",
    price: "2,00€",
    desc: "Espresso con aggiunta di liquore a scelta.",
  },

  // 🍹 Bevande fredde
  {
    name: "Ice Coffee",
    price: "3,00€",
    desc: "Caffè freddo con ghiaccio e aroma delicato.",
  },
  { name: "Ice Tea", price: "3,00€", desc: "Tè freddo rinfrescante." },
  {
    name: "Spremuta di Arancia",
    price: "3,50€",
    desc: "Succo fresco d’arancia spremuta.",
  },
  {
    name: "Spremuta di Limone",
    price: "3,00€",
    desc: "Succo fresco di limone.",
  },
  {
    name: "Acqua Menta",
    price: "3,00€",
    desc: "Bevanda fresca aromatizzata alla menta.",
  },
  {
    name: "Succo di Mirtilli",
    price: "3,00€",
    desc: "Succo naturale di mirtilli.",
  },
  {
    name: "Faluda (Latte alla Fragola)",
    price: "3,00€",
    desc: "Bevanda dolce al latte e fragola.",
  },
  {
    name: "Succhi Vari (ACE, Pera, Pesca, Ananas, Mango, Mela)",
    price: "2,50€",
    desc: "Ampia selezione di succhi naturali.",
  },
  {
    name: "Coca-Cola / Fanta / Sprite",
    price: "2,50€",
    desc: "Bibite gassate classiche.",
  },
];

const food = [
  // 🥐 Dolci & Snack
  { name: "Brioche", price: "1,70€", desc: "Brioche fresca e soffice." },
  { name: "Biscotti", price: "1,00€", desc: "Biscotti croccanti e gustosi." },
  { name: "Tortine", price: "1,00€", desc: "Piccole tortine monoporzione." },
  {
    name: "Muffin",
    price: "1,50€",
    desc: "Muffin dolci con crumble croccante.",
  },
  { name: "Crostate", price: "1,80€", desc: "Crostate artigianali." },
  { name: "Tramezzini", price: "1,80€", desc: "Piccoli panini freschi." },
  { name: "Crostatini", price: "2,00€", desc: "Crostatine dolci o salate." },

  // 🥪 Panini & Toast
  {
    name: "Toast Classico",
    price: "4,00€",
    desc: "Prosciutto e formaggio, filante.",
  },
  {
    name: "Toast Verdure",
    price: "4,50€",
    desc: "Toast con verdure grigliate.",
  },
  {
    name: "Panino Cotto & Formaggio",
    price: "4,00€",
    desc: "Panino con prosciutto cotto e formaggio.",
  },
  {
    name: "Panino Crudo & Formaggio",
    price: "4,50€",
    desc: "Panino con prosciutto crudo e formaggio.",
  },
  { name: "Piadina", price: "5,00€", desc: "Piadina farcita a scelta." },

  // 🥗 Insalate & Secondi
  {
    name: "Insalatona",
    price: "8,00€",
    desc: "Insalata abbondante con ingredienti freschi.",
  },
  {
    name: "Cotoletta di Pollo con Insalata",
    price: "9,00€",
    desc: "Secondo piatto con contorno di insalata.",
  },
  { name: "Salse", price: "0,50€", desc: "Salse extra a scelta." },

  // 🍽️ Pranzo (Solo su prenotazione)
  {
    name: "Menu Pranzo",
    price: "10,00€",
    desc: "Pasta al pomodoro / Penne al tonno / Tagliatelle al ragù + Vino/Prosecco/Acqua + Caffè.",
  },
];

/* =========================
   COMPONENTE ITEM
========================= */
interface MenuItemProps {
  item: {
    name: string;
    price: string;
    desc: string;
  };
}

function MenuItem({ item }: MenuItemProps) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 4,
        transition: "0.25s",
        "&:hover": {
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          transform: "translateY(-3px)",
        },
      }}
    >
      <CardContent sx={{ display: "flex", gap: 2 }}>
        <Avatar sx={{ bgcolor: brown }}>{item.name.charAt(0)}</Avatar>

        <Box flex={1}>
          <Box display="flex" justifyContent="space-between">
            <Typography fontWeight="bold">{item.name}</Typography>
            <Typography fontWeight="bold" color={brown}>
              {item.price}
            </Typography>
          </Box>

          <Typography fontSize={14} color="text.secondary">
            {item.desc}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

/* =========================
   PAGINA MENU
========================= */
export default function CrushCoffee() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      {/* HERO */}
      <Box
        sx={{
          py: 14,
          textAlign: "center",
          //bgcolor: "white",
          backgroundImage: `url(${hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
        }}
      >
        <Typography fontSize={{ xs: 42, md: 64 }} fontWeight="bold">
          Menu
        </Typography>

        <Typography mt={2}>
          Dal caffè del mattino all’aperitivo serale. Rilassati, lavora, resta.
        </Typography>
      </Box>

      {/* DRINKS */}
      <Container sx={{ py: 10 }}>
        <Typography variant="h4" fontWeight="bold" mb={5} textAlign="center">
          ☕ Bevande
        </Typography>

        <Stack
          spacing={3}
          sx={{
            width: { xs: "100%", md: "70%", lg: "55%" },
            mx: "auto",
          }}
        >
          {drinks.map((item, i) => (
            <MenuItem key={i} item={item} />
          ))}
        </Stack>
      </Container>

      {/* FOOD */}
      <Box sx={{ bgcolor: "#fffaf5", py: 10 }}>
        <Container>
          <Typography variant="h4" fontWeight="bold" mb={5} textAlign="center">
            🥐 Caldo & Fresco
          </Typography>

          <Stack
            spacing={3}
            sx={{
              width: { xs: "100%", md: "70%", lg: "55%" },
              mx: "auto",
            }}
          >
            {food.map((item, i) => (
              <MenuItem key={i} item={item} />
            ))}
          </Stack>
        </Container>
      </Box>
    </>
  );
}
{
  /* CTA 
<Box
  sx={{
    textAlign: "center",
    py: 12,
  }}
>
  <Typography variant="h4" fontWeight="bold">
    Porta il menu con te
  </Typography>

  <Typography color="text.secondary" mt={2}>
    Scarica la versione PDF stampabile o vieni a trovarci di persona.
  </Typography>

  <Button
    variant="contained"
    sx={{
      mt: 4,
      bgcolor: brown,
      px: 5,
      py: 1.5,
      borderRadius: 8,
      fontSize: 16,
      "&:hover": { bgcolor: "#4e3728" },
    }}
  >
    Scarica PDF
  </Button>
</Box>
      */
}
